import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@/components/theme-provider';
import { TooltipProvider } from '@/components/ui/tooltip';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import AuthProvider from '@/components/providers/AuthProvider';
import { IntlProvider } from 'react-intl';
import { keycloak } from './keycloak';
import CadastroPage from '@/pages/cadastro/CadastroPage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Cadastro de corretora nova (link dos planos no site): público, sem iniciar o login do Keycloak
if (window.location.pathname.startsWith('/cadastro')) {
  root.render(
    <React.StrictMode>
      {/* Sempre claro, como o site (chave própria: não usa o tema escolhido no sistema) */}
      <ThemeProvider defaultTheme='light' storageKey='theme-cadastro'>
        <CadastroPage />
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  // Sem sessão, o Keycloak redireciona para a tela de login e volta para a mesma URL
  keycloak.init({ onLoad: 'login-required', pkceMethod: 'S256', checkLoginIframe: false })
    .then(() => root.render(
      <React.StrictMode>
        <IntlProvider locale="pt">
          <ThemeProvider defaultTheme='system' storageKey='theme-ui'>
            <TooltipProvider>
              <AuthProvider>
                <RouterProvider router={router} />
              </AuthProvider>
            </TooltipProvider>
          </ThemeProvider>
        </IntlProvider>
      </React.StrictMode>
    ))
    .catch(() => root.render(
      <p style={{ fontFamily: 'system-ui, sans-serif', padding: 24 }}>
        {window.isSecureContext
          ? 'Não foi possível conectar ao servidor de login. Tente novamente em alguns minutos.'
          // keycloak-js usa a Web Crypto API, que o navegador só libera em HTTPS ou localhost
          : `O login só funciona por HTTPS ou localhost. Abra o sistema por https:// (ou, em desenvolvimento, libere ${window.location.origin} como origem segura no navegador).`}
      </p>
    ));
}
